<template>
  <div class="waybill-review">
    <div class="left-box">
      <div class="left-box-content">
        <div class="content-box1">
          <div class="search-form-box">
            <el-row :gutter="20">
              <el-form inline>
                <el-col :span="18">
                  <el-form-item>
                    <el-input
                      style="width: 100%"
                      clearable
                      v-model="searchForm.keyword"
                      autocomplete="off"
                      placeholder="请输入姓名/手机号码" />
                  </el-form-item>
                </el-col>

                <el-col :span="6">
                  <el-form-item label="">
                    <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                    <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <template v-if="tableData && tableData.length > 0">
            <div
              class="custom-table-box"
              v-loading="tableOptions.loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255,0.8)">
              <div
                class="table-list"
                :class="
                  item.orderId === selectOrderId ? 'table-list-select' : ''
                "
                v-for="(item, index) in tableData"
                :key="item.orderId"
                @click="handleSelectOrder(item, index)">
                <div class="list-content-left">
                  <div class="list-top">
                    <div class="list-top-left">
                      <div class="left1-box" v-for="(item2, index) in item.pointList" :key="index">
                        <div class="left1-box-top">
                          <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                            {{ item2.loadType === 1 ? "装" : "卸" }}
                          </div>
                          <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                        </div>
                        <!--                        <div class="date">-->
                        <!--                          <div>-->
                        <!--                            {{ $day.fd(item2.startTime, item2.endTime) }}-->
                        <!--                          </div>-->
                        <!--                          &lt;!&ndash;                          <div>{{ item2.endTime }}</div>&ndash;&gt;-->
                        <!--                        </div>-->
                      </div>
                    </div>
                  </div>
                  <div class="list-bottom">
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">下单时间</div>
                      <div class="bottom-box-value">
                        <CustomTooltip :text="item.createTime"></CustomTooltip>
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">订单编号</div>
                      <div class="bottom-box-value">
                        <CustomTooltip :text="item.orderNo"></CustomTooltip>
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">货主名称</div>
                      <div class="bottom-box-value">
                        <CustomTooltip :text="item.ownerName"></CustomTooltip>
                      </div>
                    </div>
                    <div class="list-bottom-box">
                      <div class="bottom-box-name">货主手机号码</div>
                      <div class="bottom-box-value">
                        <CustomTooltip :text="item.ownerPhone"></CustomTooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="no-data" v-else>
            <el-empty :image-size="100" description="暂无待审核订单"></el-empty>
          </div>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleSizeChange"
              :current-page="tableOptions.pageNumber"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="tableOptions.pageSize"
              background
              layout="total, prev, pager, next, sizes, jumper"
              :total="tableOptions.total" />
          </div>
        </div>
      </div>
    </div>
    <div class="right-box" v-loading="loading">
      <div class="right-content" v-if="selectOrderId">
        <address-template :detail="detail"></address-template>
        <cargo-template :detail="detail"></cargo-template>
        <third-order-template :detail="detail"></third-order-template>
        <order-status-step :details="detail"></order-status-step>
        <driver-template :detail="detail"></driver-template>
        <order-base-template :detail="detail"></order-base-template>
        <div class="list-status">
          <div class="list-carInfo">
            <!--            <div class="title-box">-->
            <!--              <el-image :src="cheImage" class="title-label"></el-image>-->
            <!--              系统价格计算金额-->
            <!--            </div>-->
              <div style="margin: 20px">
                  <span v-if="detail.orderFrom === 21">
                      第三方报价：
                      <span style="font-size: 18px;color: #0a65f0">{{detail.quotes}}元</span>
                    </span>
              </div>
            <div class="order-price">
              <template>
                <div class="title-box">
                  客户需支付（含票）：
                  <span class="price ">{{ detail.payableFee }}元</span>
                </div>
                <el-row class="price-des-box">
                  <el-col :span="12" class="label-val">
                    <span class="label">初始运单价格：</span>
                    <span class="value">￥{{ detail.sourceFee }}</span>
                  </el-col>
                  <el-col :span="12" class="label-val">
                    <span class="label">优惠/加价后价格：</span>
                    <span class="value">￥{{ detail.fee }}</span>
                  </el-col>
                  <el-col :span="12" class="label-val">
                    <span class="label">代理商运营费：</span>
                    <span class="value">￥{{ detail.agentFee }}</span>
                  </el-col>
                  <el-col :span="12" class="label-val">
                    <span class="label">发票价格：</span>
                    <span class="value">￥{{ detail.invoiceFee }}</span>
                  </el-col>
                </el-row>
              </template>
              <el-button type="primary" :loading="submitLoading" @click="handleSubmit">审核通过</el-button>
              <el-button type="error" @click="handleSubmitNo" style="margin-left: 16px">审核不通过</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>
        <el-empty :image-size="100" description="点击左侧订单查询详情"></el-empty>
      </div>
    </div>
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <calculatePrice ref="calculatePrice" @refreshData="refreshData"></calculatePrice>
  </div>
</template>
<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import {feeConfirm, getFeeConfirmPage} from "../api";
import tableMixin from "@/mixin/tableMixin";
import CustomSortBox from "@/components/customComponents/CustomSortBox.vue";
import addOrEdit from "../addOrEdit.vue";
import { validatePrice } from "@/utils/validate";
import CustomTooltip from "@/components/CustomTooltip.vue";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import {getLocalLabel} from "@/utils/localDict";
import {detailInfo} from "@/views/SchedulingWorkbench/OrderReassignment/api";
import calculatePrice from "./calculatePrice.vue"
import orderStatusStep from "@/components/orderStatusStep.vue";
import DriverTemplate from "@/components/customComponents/driverTemplate.vue";
import OrderBaseTemplate from "@/components/customComponents/orderBaseTemplate.vue";
import ThirdOrderTemplate from "@/components/customComponents/thirdOrderTemplate.vue";
import CargoTemplate from "@/components/customComponents/cargoTemplate.vue";
import OrderFeeTemplate from "@/components/customComponents/orderFeeTemplate.vue";
import AddressTemplate from "@/components/customComponents/addressTemplate.vue";
export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    AddressTemplate, OrderFeeTemplate, CargoTemplate,
    ThirdOrderTemplate, OrderBaseTemplate, DriverTemplate, orderStatusStep,
    CustomTooltipMultiple,
    CustomSortBox,
    OperateBox,
    calculatePrice,
    CustomTable,
    CustomDateRange,
    addOrEdit,
    CustomTooltip,
  },
  data() {
    return {
      detail: {},
      form: {
        fee: "",
        orderId: "",
      },
      rules: {
        fee: [
          { required: true, message: "金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
      loading: false,
      submitLoading: false,
      cheImage: require("@/assets/imgs/title.png"),
      detailImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      selectDriverLabel: "myDriver",
      isOver: false,
      getTableMethod: getFeeConfirmPage,
      searchForm: {
        keyword: "",
      },
      isImmediatelyGetData: true,
      selectOrderId: "",
    }
  },
  methods: {
    getLocalLabel,
    refreshData() {
      this.selectOrderId = ""
      this.$emit("success")
      this.getTableData()
    },
    openDetail(item) {
      this.$refs.detail.init(item);
    },
    handleChange(val) {
      this.selectTab = val;
      this.$emit("changeTab", this.selectTab);
    },
    handleSelectOrder(item, index) {
      this.selectOrderId = item.orderId;
      this.form.fee = "";
      this.getOrderDetail(item.orderId);
    },
    getOrderDetail(orderId) {
      this.loading = true;
      detailInfo(orderId)
          .then((res) => {
            this.loading = false;
            if (res.code === 200) {
              this.detail = res.data;
              this.$refs.form.resetFields();
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // 审核不通过
    handleSubmitNo() {
      this.$refs.calculatePrice.init(this.detail)
    },
    // 审核通过
    handleSubmit() {
      this.$confirm(
        `订单金额为${this.detail.payableFee}元，提交后无法修改，请谨慎检查？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.submitLoading = true;
        const par = {
          orderId: this.selectOrderId,
          sourceFee: "",
          pass: true,
        };
        feeConfirm(par)
          .then((res) => {
            this.submitLoading = false;
            if (res.code === 200) {
              this.$message.success("审核通过");
              this.$emit("success")
              this.selectOrderId = "";
              this.tableOptions.currentPage = 1;
              this.getTableData();
            }
          })
          .catch((e) => {
            this.submitLoading = false;
          });
      });
    },
  },
}
</script>

<style scoped lang="scss">
.waybill-review{
  width: 100%;
  height: 100%;
  display: flex;

  .left-box {
    box-sizing: border-box;
    width: 40%;
    .left-box-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      //padding: 0.2rem;
      padding-bottom: 0.2rem;
      box-sizing: border-box;
      border-radius: 0.08rem;

      .custom-table-box {
        //max-height: 90%;
        overflow-y: auto;
        padding-top: 0;

        .table-list {
          width: 100%;
          background: #fbfcff;
          margin-bottom: 0.2rem;
          padding: 0.12rem 0.1rem;
          box-sizing: border-box;
          border: 0.01rem solid #fbfcff;
          border-radius: 0.08rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          .list-content-left {
            flex: 1;
          }
          .list-content-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            padding-top: 0.1rem;
            box-sizing: border-box;
            padding-left: 0.2rem;
            .right-default {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #eaf1ff;
              color: #1269ff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0.1rem;
            }
            .right-primary {
              width: 0.64rem;
              height: 0.21rem;
              border-radius: 0.04rem;
              background-color: #1269ff;
              color: #ffffff;
              font-size: 0.12rem;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .list-top {
            display: flex;
            justify-content: space-between;
            .list-top-left {
              display: flex;
              .left1-box {
                padding-right: 0.35rem;
                position: relative;
                .left1-box-top {
                  display: flex;
                  align-items: center;
                  .label {
                    flex-shrink: 0;
                    width: 0.2rem;
                    height: 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.02rem;
                    font-size: 0.12rem;
                  }
                  .zhuang {
                    color: #5cc41a;
                    background-color: rgba(92, 196, 26, 0.3);
                  }
                  .xie {
                    color: #e52019;
                    background-color: rgba(229, 32, 25, 0.3);
                  }
                  .name {
                    color: #000000;
                    font-size: 0.18rem;
                    line-height: 0.2rem;
                    padding-left: 0.04rem;
                  }
                }
                .date {
                  color: #8c8c8c;
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                }
              }
              .left1-box::before {
                content: "→";
                position: absolute;
                right: 0.15rem;
                top: 0rem;
                font-size: 0.2rem;
                color: #52c41a;
              }
              .left1-box:nth-last-of-type(1)::before {
                display: none;
              }
            }
            .list-top-right {
              .right-ding {
                font-size: 0.12rem;
                .ding {
                  color: #eeeeee;
                }
              }
              .right-money {
                display: flex;
                justify-content: right;
                align-items: baseline;
                color: #faad14;

                .unit {
                  font-size: 0.12rem;
                  padding-left: 0.04rem;
                }
              }

              .right-box2 {
                display: flex;
                align-items: center;
                .right-box2-time {
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                  color: #8c8c8c;
                  margin-right: 0.1rem;
                }
                .right-box2-label {
                  background-color: #fff7e6;
                  color: #fa8c16;
                  font-size: 0.12rem;
                  line-height: 0.22rem;
                  border-radius: 0.1rem;
                  padding: 0 0.1rem;
                }
              }
            }
          }
          .list-bottom {
            width: 100%;
            display: flex;
            padding: 0.2rem 0 0;
            .list-bottom-box {
              width: 25%;
              display: flex;
              flex-direction: column;
              position: relative;
              padding-left: 0.1rem;
              box-sizing: border-box;
              .bottom-box-name {
                color: #8c8c8c;
                font-size: 0.12rem;
                margin-bottom: 0.1rem;
              }
              .bottom-box-value {
                color: #434343;
                font-size: 0.14rem;
              }
            }
            .list-bottom-box::before {
              content: "";
              position: absolute;
              right: 0;
              top: 0.08rem;
              width: 0.01rem;
              height: 0.26rem;
              background-color: #dce5f5;
            }
            .list-bottom-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .car-box {
            display: flex;
            align-items: center;
            border-top: 0.01rem dashed #dce5f5;
            padding: 0.1rem 0 0;
            .list-1 {
              display: flex;
              align-items: center;

              .label-img {
                width: 0.14rem;
                height: 0.14rem;
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
                font-size: 0.14rem;
                color: #52c41a;
              }
            }
            .list-2,
            .list-3 {
              font-size: 0.12rem;
              color: #8c8c8c;
            }
            .list-2 {
              padding: 0 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
              &::after {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
              }
            }
          }
        }
        .table-list-select {
          border-color: #1269ff;
          background-color: rgba(18, 105, 255, 0.05);
        }
      }
      .pagination-box {
        display: flex;
        justify-content: right;
        padding: 0.2rem 0.2rem 0.2rem 0;
        background-color: #fff;
      }
    }
  }
  //.search-form-box {
  //  flex-shrink: 0;
  //}
  .custom-table-box {
    flex: 1;
  }
  .pagination-box {
    position: sticky;
    bottom: 0;
  }
  .right-box {
    flex: 1;
    padding: 0 0.2rem 0.2rem;
    box-sizing: border-box;

    .right-content {
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }
  }
  .money {
    font-size: 0.18rem;
    color: #faad14;
  }

  .right-box {
    width: 30%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    //padding: 0.2rem 0.2rem 0.2rem 0;
    .bottom-box-value {
      text-align: center;
    }
    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      padding-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }
      .right-search {
        margin: 0.15rem 0 0;
      }
      .sort-car {
        padding: 0.1rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      padding-top: 0.2rem;
      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        overflow: hidden;
        position: relative;
        .label-box {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 0 0 0.08rem;

          width: 0.79rem;
          height: 0.29rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.12rem;
        }
        .label-box1 {
          background: rgba(250, 173, 20, 0.15);
          color: #faad14;
        }
        .label-box2 {
          background: rgba(82, 196, 26, 0.15);
          color: #52c41a;
        }
        .label-box3 {
          background: rgba(18, 105, 255, 0.15);
          color: #1269ff;
        }
        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;
          .left-box {
            display: flex;
            align-items: center;
            .center-box-1 {
              display: flex;
              align-items: center;
              .label-name {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.12rem;
                background-color: rgba(18, 105, 255, 0.05);
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }
            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;
            .default-icon {
              color: #eeeeee;
            }
            .selected-icon {
              color: #52c41a;
            }
          }
        }
        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;
          .car-list {
            display: flex;
            align-items: center;
            padding: 0.08rem 0;
            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }
            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }
        .car-operate {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0.1rem 0;
          background-color: #f4f6fd;
          margin: 0 -0.1rem;
          .operate-list {
            display: flex;
            align-items: center;
            position: relative;
            .operate-img {
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.02rem;
            }
            .operate-txt {
              font-size: 0.12rem;
              color: #434343;
            }
          }
          .operate-line {
            width: 0.01rem;
            height: 0.14rem;
            background-color: #e3e7ed;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
    .right-content {
      height: 100%;
      padding: 0.2rem 0.16rem;
      box-sizing: border-box;
      .list-top {
        display: flex;
        justify-content: space-between;
        .list-top-left {
          display: flex;
          .left1-box {
            padding-right: 0.35rem;
            position: relative;
            .left1-box-top {
              display: flex;
              align-items: center;
              .label {
                flex-shrink: 0;
                width: 0.2rem;
                height: 0.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0.02rem;
                font-size: 0.12rem;
              }
              .zhuang {
                color: #5cc41a;
                background-color: rgba(92, 196, 26, 0.3);
              }
              .xie {
                color: #e52019;
                background-color: rgba(229, 32, 25, 0.3);
              }
              .name {
                color: #000000;
                font-size: 0.18rem;
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .date {
              color: #8c8c8c;
              font-size: 0.12rem;
              line-height: 0.2rem;
            }
          }
          .left1-box::before {
            content: "→";
            position: absolute;
            right: 0.15rem;
            top: 0rem;
            font-size: 0.2rem;
            color: #52c41a;
          }
          .left1-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
        .list-top-right {
          .right-money {
            display: flex;
            justify-content: right;
            align-items: baseline;
            color: #faad14;
            .money {
              font-size: 0.18rem;
            }
            .unit {
              font-size: 0.12rem;
              padding-left: 0.04rem;
            }
          }
          .right-box2 {
            display: flex;
            align-items: center;
            .right-box2-time {
              font-size: 0.12rem;
              line-height: 0.2rem;
              color: #8c8c8c;
              margin-right: 0.1rem;
            }
            .right-box2-label {
              background-color: #fff7e6;
              color: #fa8c16;
              font-size: 0.12rem;
              line-height: 0.22rem;
              border-radius: 0.1rem;
              padding: 0 0.1rem;
            }
          }
        }
      }
      .list-box {
        background: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.1rem;
        box-sizing: border-box;
        margin-top: 0.2rem;
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.08rem 0;
          box-sizing: border-box;
          .list-bottom-box {
            width: 14%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            box-sizing: border-box;
            .list-image {
              width: 0.6rem;
              height: 0.6rem;
              border-radius: 0.05rem;
            }
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.06rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
            }
          }
          .list-bottom-box3 {
            width: 40%;
            align-items: flex-start;
            padding-left: 5%;
            box-sizing: border-box;
          }
          .list-bottom-box2 {
            width: 20%;
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.06rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
          .list-bottom-box4 {
            width: 35%;
          }
          .list-bottom-box5 {
            width: 10%;
          }
        }
        //.list-bottom2 {
        //  .list-bottom-box:nth-last-of-type(1):before,
        //  .list-bottom-box:nth-last-of-type(2):before,
        //  .list-bottom-box:nth-last-of-type(3):before,
        //  .list-bottom-box:nth-last-of-type(4):before {
        //    display: none;
        //  }
        //}
      }
      .list-status {
        display: flex;
        .title-box {
          padding: 0.2rem 0 0;
          .title-label {
            width: 0.08rem;
            height: 0.08rem;
            margin-right: 0.06rem;
          }
        }
        .list-step {
          width: 25%;
          padding-left: 0.4rem;
          box-sizing: border-box;
        }
        .list-carInfo {
          width: 100%;
        }
        .list-label {
          padding: 0.1rem 0;
        }
        //.list-step-box {
        //  display: flex;
        //  flex-direction: column;
        //  padding: 0 0.3rem 0 0.5rem;
        //  box-sizing: border-box;
        //  .step-list {
        //    border-radius: 0.1rem;
        //    background: #ffffff;
        //    padding: 0.04rem 0.14rem;
        //    box-sizing: border-box;
        //    margin-bottom: 0.5rem;
        //    position: relative;
        //    .step-date {
        //      font-size: 0.12rem;
        //      height: 0.22rem;
        //    }
        //    .step-content {
        //      font-size: 0.14rem;
        //    }
        //  }
        //  .step-list::before {
        //    content: "";
        //    position: absolute;
        //  }
        //}
        .color8c8c8c {
          color: #8c8c8c;
        }
        .color434343 {
          color: #434343;
        }
        .bgEDF4FF {
          background-color: #edf4ff;
        }
      }
      .siji-image,
      .ding-image {
        width: 0.2rem;
        height: 0.2rem;
      }
      .stepper {
        box-sizing: border-box;
        .step {
          position: relative;
          padding-left: 0.3rem;
          margin-bottom: 0.5rem;
          .step-box {
            background-color: #edf4ff;
            border-radius: 0.1rem;
            padding: 0.04rem 0.14rem;
            box-sizing: border-box;
          }
        }

        .step:last-child {
          margin-bottom: 0;
        }

        .step::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.15rem;
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background-color: #d9dadc;
          box-shadow: 0px 0.04rem 0.04rem 0px rgba(0, 0, 0, 0.06);
        }

        .step::after {
          content: "";
          position: absolute;
          left: 0.04rem;
          top: 0.27rem;
          width: 0.02rem;
          height: 190%;
          background-color: #dce5f5;
        }

        .step:last-child::after {
          display: none;
        }

        .step-time {
          font-size: 0.12rem;
          color: #666;
          margin-bottom: 0.05rem;
        }

        .step-content {
          font-size: 0.14rem;
        }
      }
    }
  }
  .tab-box {
    margin-bottom: 0.2rem;
  }
  .content-box1 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .to-tab {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0 0.16rem;
      box-sizing: border-box;
    }
  }
  .content-box2 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }
  .list-bottom-img {
    .list-bottom {
      padding-left: 0.3rem !important;
    }
    .list-bottom-box {
      width: auto !important;
    }
    .list-bottom-box:before {
      display: none;
    }
    .list-image {
      margin-right: 0.1rem;
    }
  }
  .order-price {
    .order-price-tip {
      font-size: 0.12rem;
      color: #8c8c8c;
      line-height: 0.2rem;
      padding: 0.2rem 0 0.1rem;
    }
  }
}
.order-price{
  .title-des{
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.6);
  }
  .input-price{
    margin: 0.1rem 0;
  }
  .price{
    color: #0a65f0;
    font-size: 0.18rem;
  }
  .price-des-box{
    background-color: rgba(0,0,0,0.05);
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    padding-bottom: 0.1rem;
    border-radius: 5px;
    margin: 0.15rem 0 0.15rem;
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .label-val{
    padding: 0.08rem 0;
    .label{
      color: #000000;
    }
    .value{
      color: #0a65f0;
      font-size: 0.18rem;
    }
  }
}
.address{
  padding: 0.1rem 0;
}
</style>
